import styled, { css } from 'styled-components';

export const MainTitle = styled.h4`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.snappyBlue.extraDark[10]};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px auto;
    text-align: center;
    max-width: 285px;
  `}
`;

export const CardItemsBlock = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.brand.snappyBlue.ultraLight[98]};
    border-radius: 16px;
    padding: 24px;
  `}
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  margin: 0px;
  padding: 0px;
`;

export const CardItemTitle = styled.span`
  ${({ theme }) => css`
    align-items: center;
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px;
    justify-content: flex-start;
    line-height: ${theme.v2.font.lineHeight.list};
  `}
`;

export const CardItemDescription = styled.li`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.list};
    margin-left: 24px;
  `}
`;

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 8px 0px 0px;
  `}
`;

export const ActionRow = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-top: 32px;
`;

export const Image = styled.img`
  display: flex;
  margin: 24px auto 0px;
  max-width: 152px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  flex-direction: column;
`;

export const LoadingText = styled.span`
  ${({ theme }) => css`
      color: ${theme.v2.colors.neutral.lowMedium};
      font-size: ${theme.v2.font.sizes.xxs};
      font-weight: ${theme.v2.font.weights.medium};
      line-height: ${theme.v2.font.lineHeight.text};
      margin: 16px auto 92px;
      max-width: 452px;
      text-align: center;
    `}
`;
